module.exports = __webpack_public_path__ + "static/img/r_017.aac0fae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic/r_017.jpg
// module id = NzVC
// module chunks = 1